import "./HomePage.css";

import {
	Card,
	CardContent,
	Grid,
	Typography,
} from "../../common/MaterialComponent";
import React, { useEffect, useState } from "react";

import { GetGTLDetailPartFor } from "../../api/homePageController";
import { HomePageDescription } from "./Description/HomePageDescription";
import { HomePageFeeds } from "./LatestFeeds/HomePageFeeds";
import { HomePageVideo } from "./Video/HomePageVideo";
import { useGetComponentStringsContext } from "../../hooks/useGetComponentStrings";

export const HomePage: React.FC = () => {
	const [description, setDescription] = useState<string | undefined>(undefined);
	const [errDescription, setErrDescription] = useState<string | undefined>(
		undefined
	);
	const [video, setVideo] = useState<string | undefined>(undefined);
	const [errVideo, setErrVideo] = useState<string | undefined>(undefined);
	const [latestFeeds, setLatestFeeds] = useState<string[] | undefined>(
		undefined
	);
	const [errLatestFeeds, setErrLatestFeeds] = useState<string | undefined>(
		undefined
	);
	const [batchNumber, setBatchNumber] = useState(2);
	const [displayLoadMoreButton, setDisplayLoadMoreButton] = useState(true);

	const strings = useGetComponentStringsContext().HomePage;

	useEffect(() => {
		const getStatePartFor = (part: string) => {
			switch (part) {
				case "Description":
					return {
						setter: setDescription,
						seterr: setErrDescription,
					};
				case "Video":
					return { setter: setVideo, seterr: setErrVideo };
				case "LatestFeeds":
					return {
						setter: setLatestFeeds,
						seterr: setErrLatestFeeds,
					};
				default:
					//should never occur
					return {
						setter: setDescription,
						seterr: setErrDescription,
					};
			}
		};

		const getGTLDetail = async (part: string) => {
			const { setter, seterr } = getStatePartFor(part);
			try {
				const res = await GetGTLDetailPartFor(part);
				if (res.error) {
					seterr(res.error);
				} else {
					setter(res.responseObj);
				}
			} catch (err) {
				seterr(err);
			}
		};

		const getInitialData = async () => {
			await getGTLDetail("Video");
			await getGTLDetail("Description");
			await getGTLDetail("LatestFeeds");
		};

		getInitialData();
	}, []);

	const getMoreFeeds = async () => {
		try {
			const res = await GetGTLDetailPartFor("LatestFeeds", batchNumber);
			if (res.error) {
				setErrLatestFeeds(res.error);
			} else {
				if (res.responseObj !== undefined && latestFeeds !== undefined) {
					//merge new feeds
					setLatestFeeds((oldFeeds) => [
						...(oldFeeds !== undefined ? oldFeeds : []),
						...(res.responseObj as string[]),
					]);

					if (res.responseObj.length < 10) {
						//less than 10 so end of table so disable button
						setDisplayLoadMoreButton(false);
					} else {
						//more than 10 so increment batch counter fo when they click again
						setBatchNumber(batchNumber + 1);
					}
				}
			}
		} catch (err) {
			setErrLatestFeeds(err);
		}
	};

	return (
		<div className="homePageContainer">
			<>
				<Card elevation={2}>
					<CardContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h6" noWrap color="textSecondary">
									<b>{strings.welcomeMessage}</b>
								</Typography>
							</Grid>
							<Grid item xs={12} sm={6}>
								<HomePageVideo video={video} error={errVideo} />
							</Grid>

							<Grid item xs={12} sm={6}>
								<HomePageDescription
									description={description}
									error={errDescription}
								/>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
				<HomePageFeeds
					latestFeeds={latestFeeds}
					error={errLatestFeeds}
					displayLoadMoreButton={displayLoadMoreButton}
					loadMore={getMoreFeeds}
				/>
			</>
		</div>
	);
};
